<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_settings"
      class="scaling-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <g id="Icon_settings-2" data-name="Icon_settings" transform="translate(1.167 1.167)">
        <path
          id="Shape"
          d="M6.375,12h-.75a.751.751,0,0,1-.75-.75l-.09-.63a.749.749,0,0,0-1.192-.494l-.509.382a.751.751,0,0,1-1.061,0l-.53-.53a.751.751,0,0,1,0-1.061l.382-.51A.75.75,0,0,0,1.38,7.215l-.63-.09A.751.751,0,0,1,0,6.375v-.75a.751.751,0,0,1,.75-.75l.63-.09a.75.75,0,0,0,.494-1.192l-.382-.509a.752.752,0,0,1,0-1.061l.53-.53a.751.751,0,0,1,1.061,0l.509.382A.749.749,0,0,0,4.785,1.38l.09-.63A.751.751,0,0,1,5.625,0h.75a.751.751,0,0,1,.75.75l.09.63a.749.749,0,0,0,1.192.494l.51-.382a.75.75,0,0,1,1.061,0l.53.53a.752.752,0,0,1,0,1.061l-.382.509a.75.75,0,0,0,.494,1.192l.63.09a.751.751,0,0,1,.75.75v.75a.751.751,0,0,1-.75.75l-.63.09a.75.75,0,0,0-.494,1.192l.382.51a.751.751,0,0,1,0,1.061l-.53.53a.75.75,0,0,1-1.061,0l-.51-.382a.749.749,0,0,0-1.192.494l-.09.63A.751.751,0,0,1,6.375,12ZM6,3A3,3,0,1,0,9,6,3,3,0,0,0,6,3Z"
          transform="translate(-0.167 -0.167)"
        />
        <path
          id="Path"
          d="M2.333,1.167A1.167,1.167,0,1,1,1.167,0,1.167,1.167,0,0,1,2.333,1.167Z"
          transform="translate(4.667 4.667)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SettingsIcon extends Vue {}
</script>

<style>
</style>
